import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { getEventPosition } from '../../../utils/scene/utils/events/convert';

const isBetween = (pos, interval) => {
  return pos >= interval[0] && pos <= interval[1];
};

export const ProcedureDragArea = ({
  setLastActive,
  activeRoutine,
  setActiveRoutine,
  routineAreas,
  setRoutinesPool,
  setActiveArea,
}) => {
  const [dragItem, setDragItem] = useState(null);
  const [areasPosition, setAresPosition] = useState();

  useEffect(() => {
    if (!activeRoutine) {
      setDragItem(null);
      setActiveArea(null);
      return;
    }

    setDragItem(activeRoutine);

    let underArea;

    const onMove = (e) => {
      e.preventDefault();
      e.stopPropagation();

      window?.scrollTo?.(0, 0);

      const { x, y } = getEventPosition(e);

      underArea = areasPosition?.find(({ bounding }) => {
        const xArea = [bounding.left, bounding.left + bounding.width];
        const yArea = [bounding.top, bounding.top + bounding.height];
        return isBetween(x, xArea) && isBetween(y, yArea);
      });

      setActiveArea((prev) => (underArea?.el?.id !== prev?.id ? underArea?.el : prev));

      setDragItem((prev) => {
        const { position } = prev;
        const [diffX, diffY] = [x - position.x, y - position.y];
        return { ...prev, position: { x: position.x + diffX, y: position.y + diffY } };
      });
    };

    const onEnd = () => {
      if (underArea) {
        setRoutinesPool((prev) => {
          const necessaryIndex = underArea.index;
          const onThisPlaceItem = prev[necessaryIndex];
          const isAlreadyExistIndex = prev?.findIndex((el) => activeRoutine?.id === el?.id);

          const next = [...prev];
          next[necessaryIndex] = activeRoutine;

          if (isAlreadyExistIndex !== -1) next[isAlreadyExistIndex] = onThisPlaceItem;

          return next;
        });

        setLastActive(activeRoutine);
      }

      setActiveRoutine(null);
    };

    const onStart = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    const dragEventsData = [
      { callback: onStart, listeners: ['mousedown', 'touchstart'] },
      { callback: onMove, listeners: ['mousemove', 'touchmove'] },
      { callback: onEnd, listeners: ['touchend', 'mouseup'] },
    ];

    const listenLogic = (action) => {
      dragEventsData.forEach(({ callback, listeners }) =>
        listeners.forEach((listener) =>
          window[`${action}EventListener`](listener, callback, {
            passive: false,
            capture: true,
          }),
        ),
      );
    };

    listenLogic('add');
    return () => listenLogic('remove');
  }, [areasPosition, activeRoutine]);

  useEffect(() => {
    const onResize = () => {
      const bounding = routineAreas.current.map(({ ref, el, index }) => {
        const { left, top, width, height } = ref.getBoundingClientRect();
        return { bounding: { left, top, width, height }, el, index };
      });

      setAresPosition(bounding);
    };

    onResize();

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <div className={'procedure-game__drag-area'}>
      {dragItem && (
        <div
          className={classNames('procedure-game__el', 'procedure-game__el_draggable')}
          style={{ left: dragItem.position.x, top: dragItem.position.y }}
        >
          <div className={'procedure-game__el-image-box'}>
            <div className={'procedure-game__el-image'}>
              <img src={dragItem.image} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
